import React from "react";
import Comment from "./Comment";

const CommentList = ({ item }) => {
  if (!item || !item.comments || item.comments.length === 0) return null;
  return (
    <div style={{ marginTop: "20px" }}>
      {item.comments.map((comment, i) => (
        <Comment key={i} cmt={comment} />
      ))}
    </div>
  );
};

export default CommentList;
